import React from "react";

const useRefHeight = (slideIndex: number, type: "task" | "visit") => {
  const ref = React.useRef<HTMLDivElement>(null);

  const [refHeight, setRefHeight] = React.useState(ref.current?.clientHeight ?? 0);

  React.useEffect(() => {
    const { current: footerElem } = ref;
    const footerClientHeight = footerElem?.clientHeight ?? 0;
    setRefHeight(footerClientHeight);
  }, [ref, slideIndex, type]);

  return { ref, refHeight };
};

export default useRefHeight;
